function giftboxComponent(items) {
  return {
    products: items.map((item) => item),
    variants: items.map((item) => item.variants),
    selectedOptions: items.map((item) => Array(item.options.length).fill(null)),
    // 保存每个选项选择的值

    // 获取某个属性下的值及是否可用
    getOptionValues(productIndex, optionIndex) {
      // 去重
      let values = this.variants[productIndex].map(
        (v) => v[`option${optionIndex + 1}`],
      )

      values = [...new Set(values)]

      return values.map((value) => {
        // 判断此值在当前已选条件下是否有可用的 variant
        let available = this.variants[productIndex].some((v) => {
          // 检查该 optionIndex 是否匹配
          if (v[`option${optionIndex + 1}`] !== value) return false
          // 检查其他已选的选项是否匹配
          for (let i = 0; i < this.selectedOptions[productIndex].length; i++) {
            if (i === optionIndex) continue
            if (
              this.selectedOptions[productIndex][i] &&
              v[`option${i + 1}`] !== this.selectedOptions[productIndex][i]
            ) {
              return false
            }
          }
          return v.available
        })

        return { value, available }
      })
    },
    selectedProduct: 0,
    selectProduct(productIndex) {
      this.selectedProduct = productIndex
    },

    // 用户选择某个选项
    selectOption(productIndex, optionIndex, value) {
      if (this.selectedOptions[productIndex][optionIndex] === value) {
        this.selectedOptions[productIndex][optionIndex] = null
      } else {
        this.selectedOptions[productIndex][optionIndex] = value
      }
    },

    optionClass(value, productIndex, optionIndex, isColor) {
      return [
        !value.available ? "opacity-50 cursor-not-allowed" : "",
        this.selectedOptions[productIndex][optionIndex] === value.value &&
        value.available
          ? "bg-(--ar-color-light) text-white active"
          : "",
        // this.selectedOptions[productIndex][optionIndex] === value.value &&
        // value.available &&
        // isColor
        //   ? "rounded-full"
        //   : "",
        // !isColor ? "aspect-square rounded-full" : "",
      ]
    },

    // 当前选择的具体 variant
    get selectedVariant() {
      for (
        let productIndex = 0;
        productIndex < this.selectedOptions.length;
        productIndex++
      ) {
        if (this.selectedOptions[productIndex].every((p) => p)) {
          const target = this.variants[productIndex].find((v) =>
            this.selectedOptions[productIndex].every(
              (val, i) => v[`option${i + 1}`] === val,
            ),
          )

          // console.log(target)

          // const el = document.querySelector(
          //   `[data-media-id="${target.featured_media.id}"]`,
          // )

          // if (el) {
          //   el.scrollIntoView({
          //     behavior: "smooth",
          //     block: "center",
          //   })
          // }

          return target
        }
      }
      return null
    },

    // color map

    getColor(name) {
      const shopifyColors =
        window.__ShopifyMetaObjects["shopify--color-pattern"]
      const obj = shopifyColors.reduce((acc, cur) => {
        acc[cur.label] = cur.color
        return acc
      }, {})

      return obj[name]
    },

    // add to giftbox
    giftbox: [],
    giftMax: window.__giftboxOptions.max,
    giftDuplicate: window.__giftboxOptions.duplicate,
    giftButtonDisabled: false,
    get giftButtonDisabledStyle() {
      return (
        !this.selectedVariant ||
        !this.selectedVariant.available ||
        this.giftButtonDisabled ||
        this.giftbox.length === this.giftMax
      )
    },
    get giftButtonClass() {},
    addGift() {
      if (this.selectedVariant && this.selectedVariant.available) {
        this.giftbox.push(this.selectedVariant)
      }
    },
    removeGift(giftIndex) {
      this.giftbox.splice(giftIndex, 1)
    },

    // add to cart

    cartButtonState: "default",
    cartButtonLabel: window.theme.strings.addToCart,
    cartButtonDisabled: false,
    get cartButtonDisabledStyle() {
      return (
        this.cartButtonState !== "default" ||
        this.cartButtonDisabled ||
        this.giftbox.length < this.giftMax
      )
    },
    get cartButtonClass() {
      switch (this.cartButtonState) {
        case "loading":
          return "bg-gray-300 text-white opacity-70 cursor-not-allowed"
        case "success":
          return "bg-lime-300 text-white"
        case "error":
          return "bg-red-600 text-white"
        case "soldout":
          return "bg-gray-300 text-white cursor-not-allowed"
        case "need_variant":
          return "bg-yellow-300 text-white"
        default:
          return "important-btn text-white"
      }
    },
    addCart() {
      this.setCartButtonState("loading", "Loading...")

      let items = [
        {
          id: window.__giftboxProduct.variants[0].id,
          quantity: 1,
          properties: {
            giftbox: true,
            product_id: this.giftbox.map((item) => item.id),
            product_img: this.giftbox.map((item) => item.featured_image.src),
            product_name: this.giftbox.map((item) => item.name),
          },
        },
      ]

      Alpine.store("cart")
        .addCart(items)
        .then((json) => {
          this.setCartButtonState("success", "Added")
          setTimeout(
            () =>
              this.setCartButtonState(
                "default",
                window.theme.strings.addToCart,
              ),
            1500,
          )
        })
        .catch((err) => {
          this.setCartButtonState("error", "Error adding")
          setTimeout(
            () =>
              this.setCartButtonState(
                "default",
                window.theme.strings.addToCart,
              ),
            2000,
          )
        })
    },

    setCartButtonState(newState, text) {
      this.cartButtonState = newState
      this.cartButtonLabel = text
      this.cartButtonDisabled =
        newState === "loading" ||
        newState === "soldout" ||
        newState === "limit_reached"
    },

    // stickyBottom
    isFixed: false,
    elTop: 0,
    elHeight: 0,
    init() {
      const el = this.$refs.el
      const placeholder = this.$refs.placeholder

      // 元素原本顶部位置
      this.elTop = el.getBoundingClientRect().top + window.scrollY
      this.elHeight = el.offsetHeight

      const update = () => {
        const scrollY = window.scrollY
        const isMobile = window.innerWidth < 1024

        // 移动端滚动到底前固定，否则正常流
        this.isFixed = isMobile && scrollY + window.innerHeight < this.elTop
      }

      window.addEventListener("scroll", update)
      window.addEventListener("resize", () => {
        // 高度变化时更新占位
        this.elHeight = el.offsetHeight
        update()
      })
      update()
    },
  }
}
